const Product = {
  log: window.log,
  bindStickyBar: window.bindStickyBar,

  init() {
    this.initDeliveryEstimation();
    this.bindStickyBar('.na_sticky_bar_outer', '.pdp-main', 320);
    this.initUpdate();
    this.initBundleBuilderV2ProductInfoModal();
    this.addToCart();
  },

  initBundleBuilderV2ProductInfoModal() {
    const self = this;
    let lastScrollY = null;
    const resetScrollLock = () => {
      $('body').removeClass('no-scroll');
      $('#main, #MainContent').css({
        zIndex: 'unset',
        position: 'unset'
      });
      if (lastScrollY !== null) {
        setTimeout(() => window.scrollTo({ top: lastScrollY, behavior: 'instant' }), 10);
      }
    };

    const resetProductInfoModalFlip = ($modal) => {
      $modal.find('.pdp-main-bb__product-info-flip-inner').removeClass('is-flipped');
      $modal.find('[data-product-info-face="front"]').attr('aria-hidden', 'false');
      $modal.find('[data-product-info-face="back"]').attr('aria-hidden', 'true');
    };

    $(document).on('click', '.pdp-main-bb__product-info-trigger', function (e) {
      e.preventDefault();
      const id = $(this).attr('aria-controls');
      const $modal = id ? $('#' + id) : $();
      if (!$modal.length) return;
      lastScrollY = window.scrollY;
      resetProductInfoModalFlip($modal);
      $modal.addClass('active').attr('aria-hidden', 'false').fadeIn();
      $('body').addClass('no-scroll');
      $('#main, #MainContent').css({
        zIndex: '21',
        position: 'relative'
      });
    });
    $(document).on(
      'click',
      '.pdp-main-bb__product-info-modal .modal-close, .pdp-main-bb__product-info-modal .modal-overlay',
      function () {
        const $modal = $(this).closest('.pdp-main-bb__product-info-modal');
        resetProductInfoModalFlip($modal);
        $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
        resetScrollLock();
      }
    );
    $(document).on('click', '.pdp-main-bb__product-info-add', function (e) {
      e.preventDefault();
      const $btn = $(this);
      if ($btn.prop('disabled')) return;
      const variantId = parseInt($btn.attr('data-variant-id'), 10);
      const $card = $btn.closest('.pdp-main-bb__category-product');
      if (!variantId || !$card.length) return;
      self.updateQuantity(variantId, 1, $card);
      const $modal = $btn.closest('.pdp-main-bb__product-info-modal');
      resetProductInfoModalFlip($modal);
      $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
      resetScrollLock();
    });
    $(document).on('click', '.pdp-main-bb__product-info-nutrition-info, .pdp-main-bb__product-info-image img, .pdp-main-bb__product-info-title', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $modal = $(this).closest('.pdp-main-bb__product-info-modal');
      const $inner = $modal.find('.pdp-main-bb__product-info-flip-inner');
      if (!$inner.length) return;
      $inner.addClass('is-flipped');
      $modal.find('[data-product-info-face="front"]').attr('aria-hidden', 'true');
      $modal.find('[data-product-info-face="back"]').attr('aria-hidden', 'false');
    });
    $(document).on('click', '.pdp-main-bb__product-info-flip-return', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $modal = $(this).closest('.pdp-main-bb__product-info-modal');
      resetProductInfoModalFlip($modal);
    });
  },

  initDeliveryEstimation() {
    const currentCountry = $('.countr_code_sel__js').attr('value');
    const deliveryEl = $('.pdp-main__product-delivery')
    const deliveryDaysRaw = deliveryEl.data('delivery-days');
    const deliveryMonthsRaw = deliveryEl.data('delivery-months');
    const deliveryDays = Array.isArray(deliveryDaysRaw) ? deliveryDaysRaw.map(d => d.value) : [];
    const deliveryMonths = Array.isArray(deliveryMonthsRaw) ? deliveryMonthsRaw.map(m => m.value) : [];

    const deliveryConditions = deliveryEl.data('delivery-conditions');
    const productDeliveryConditions = deliveryEl.data('product-delivery-conditions');
    const deliveryDefaultEstimation = +(deliveryEl.data('delivery-default-estimation')) || 1;
    this.log.collapse({ currentCountry, deliveryDays, deliveryMonths, deliveryConditions, productDeliveryConditions, deliveryDefaultEstimation }, "Delivery Data", "success");

    const calcEstimation = (country, conditions, defEst) =>
      (conditions || []).find(c => c.countries?.includes(country))?.delivery_estimation ?? defEst;

    const deliveryEstimation = calcEstimation(currentCountry, productDeliveryConditions || deliveryConditions, deliveryDefaultEstimation);
    this.calculateDeliveryDate(deliveryEstimation, deliveryDays, deliveryMonths, deliveryConditions);
  },

  calculateDeliveryDate(daysToAdd, days, months) {
    const currentDate = new Date();

    const addBusinessDays = (startDate, numDays) => {
      const resultDate = new Date(startDate);
      let addedDays = 0;
      while (addedDays < numDays) {
        resultDate.setDate(resultDate.getDate() + 1);
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return resultDate;
    };

    const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
    const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
    $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
  },

  formatMoney(amount) {
    return window.MoneyUtils.formatMoney(amount);
  },

  formatMoneyNoTrailingZeros(amount) {
    return window.MoneyUtils.formatMoneyNoTrailingZeros(amount);
  },

  currency: (() => {
    return window.MoneyUtils.getCurrencySymbol() || '£';
  })(),
  klarna: $('.pdp-main__klarna span'),
  selectedProducts: new Map(),
  isSubscription: true,

  bundleBuilderSelector() {
    const self = this;
    $('.pdp-main-bb__category-product-action--add').on('click', function () {
      const $product = $(this).closest('.pdp-main-bb__category-product');
      const variantId = $product.data('variant-id');
      self.addProduct(variantId, $product);
    });

    $('.pdp-main-bb__category-product-action--quantity-plus').on('click', function () {
      const variantId = $(this).data('variant-id');
      const $product = $(this).closest('.pdp-main-bb__category-product');
      self.updateQuantity(variantId, 1, $product);
    });

    $('.pdp-main-bb__category-product-action--quantity-minus').on('click', function () {
      const variantId = $(this).data('variant-id');
      const $product = $(this).closest('.pdp-main-bb__category-product');
      self.updateQuantity(variantId, -1, $product);
    });
  },

  initPreaddedProduct() {
    const preaddedVariantId = parseInt($('.pdp-main-bb__categories').first().attr('data-preadded-variant-id'), 10);
    if (!preaddedVariantId) return;

    const $product = $(`.pdp-main-bb__category-product[data-variant-id="${preaddedVariantId}"]`).first();
    if (!$product.length) return;

    if (this.selectedProducts.has(preaddedVariantId)) return;

    const hasAddButton = $product.find('.pdp-main-bb__category-product-action--add').length > 0;
    if (hasAddButton) this.addProduct(preaddedVariantId, $product);
    else this.updateQuantity(preaddedVariantId, 1, $product);
  },

  getTotalQuantity() {
    let total = 0;
    for (const [variantId, product] of this.selectedProducts) {
      total += product.quantity;
    }
    return total;
  },

  getTotalServings() {
    let total = 0;
    for (const [variantId, product] of this.selectedProducts) {
      if (product.quantity > 0) {
        total += (product.servings || 0) * product.quantity;
      }
    }
    return total;
  },

  /**
   * Single read path for selling plan id + name from markup.
   * Uses data-* attributes only (not jQuery .data()) so values stay correct after .attr() updates.
   */
  readSellingPlanFromElement($el) {
    if (!$el?.length) return { sellingPlanId: undefined, sellingPlanName: undefined };
    const id = ($el.attr('data-selling-plan-id') || '').trim();
    const name = ($el.attr('data-selling-plan-name') || '').trim();
    return {
      sellingPlanId: id || undefined,
      sellingPlanName: name || undefined
    };
  },

  /** Active subscription plan from the frequency UI: selected chip, else the sub row defaults. */
  getActiveSellingPlanFromUI() {
    const $chip = $('.pdp-main__frequency-selector-plan.active');
    if ($chip.length) return this.readSellingPlanFromElement($chip);
    return this.readSellingPlanFromElement($('.pdp-main__frequency.sub'));
  },

  applySellingPlanToSelectedProducts(plan) {
    for (const [, product] of this.selectedProducts) {
      product.sellingPlanId = plan.sellingPlanId;
      product.sellingPlanName = plan.sellingPlanName;
    }
  },

  mirrorSellingPlanOntoSubRow(plan) {
    const $sub = $('.pdp-main__frequency.sub');
    if (!$sub.length) return;
    $sub.attr('data-selling-plan-id', plan.sellingPlanId ?? '');
    $sub.attr('data-selling-plan-name', plan.sellingPlanName ?? '');
  },

  /**
   * Resolves selling plan display name for [frequency] copy.
   * Optional `hint` (e.g. line item or freshly clicked plan); else map; else active UI.
   */
  resolveFrequencyTextContext(hint) {
    if (hint?.sellingPlanName != null && String(hint.sellingPlanName).length) {
      return { sellingPlanName: String(hint.sellingPlanName) };
    }
    for (const [, p] of this.selectedProducts) {
      if (p?.sellingPlanName != null && String(p.sellingPlanName).length) {
        return { sellingPlanName: String(p.sellingPlanName) };
      }
    }
    const ui = this.getActiveSellingPlanFromUI();
    if (ui.sellingPlanName) return { sellingPlanName: ui.sellingPlanName };
    return { sellingPlanName: '' };
  },

  updateProgressBar() {
    if (typeof window.updateProgressBar === 'function') {
      const totalQuantity = this.getTotalQuantity();
      window.updateProgressBar(totalQuantity);
    }
  },

  addProduct(variantId, $product) {
    const fromCard = this.readSellingPlanFromElement($product);
    const fromUi = this.getActiveSellingPlanFromUI();
    const hasAddButton = $product.find('.pdp-main-bb__category-product-action--add').length > 0;
    const sellingPlanId = this.isSubscription ? (fromUi.sellingPlanId || fromCard.sellingPlanId) : undefined;
    const sellingPlanName = this.isSubscription ? (fromUi.sellingPlanName || fromCard.sellingPlanName) : undefined;

    const productData = {
      variantId: variantId,
      sellingPlanId,
      sellingPlanName,
      price: $product.data('price'),
      comparePrice: $product.data('compare-price'),
      subscriptionPrice: $product.data('subscription-price'),
      available: $product.data('available'),
      servings: parseInt($product.data('servings')) || 0,
      quantity: 1
    };
    this.selectedProducts.set(variantId, productData);
    this.updateProductUI(variantId, $product, hasAddButton);
    this.updateProgressBar();
    this.calculatePrice();
  },

  updateQuantity(variantId, change, $product) {
    const product = this.selectedProducts.get(variantId);
    const hasAddButton = $product.find('.pdp-main-bb__category-product-action--add').length > 0;
    const $quantityMinus = $product.find('.pdp-main-bb__category-product-action--quantity-minus');
    if (!product) {
      // If addButton is not present and change is positive, add the product
      if (!hasAddButton && change > 0) this.addProduct(variantId, $product);
      !hasAddButton && $quantityMinus.toggleClass('disabled', change <= 0);
      return;
    }

    product.quantity = Math.max(0, product.quantity + change);
    !hasAddButton && $quantityMinus.toggleClass('disabled', product.quantity === 0);
    if (product.quantity === 0) {
      this.selectedProducts.delete(variantId);
    }
    this.updateProductUI(variantId, $product, hasAddButton);
    this.updateProgressBar();
    this.calculatePrice();
  },

  updateProductUI(variantId, $product, hasAddButton) {
    const product = this.selectedProducts.get(variantId);
    const $addBtn = $product.find('.pdp-main-bb__category-product-action--add');
    const $quantityControls = $product.find('.pdp-main-bb__category-product-action--quantity');
    const $quantityValue = $product.find('.pdp-main-bb__category-product-action--quantity-value');
    if (product && product.quantity > 0) {
      if (hasAddButton) { $addBtn.addClass('hidden'); $quantityControls.removeClass('hidden'); }
      $quantityValue.text(product.quantity);
    } else {
      if (hasAddButton) { $addBtn.removeClass('hidden'); $quantityControls.addClass('hidden'); }
      $quantityValue.text('0');
    }
  },

  updateProductCardPrices() {
    const totalQuantity = this.getTotalQuantity();
    const thresholdDiscount = this.getThresholdDiscount();
    const shouldApplyThresholdDiscount = totalQuantity > 0 && thresholdDiscount > 0;

    $('.pdp-main-bb__category-product').each((index, element) => {
      const $product = $(element);

      // Get base prices from data attributes
      const oneTimePrice = parseInt($product.data('price')) || 0;
      const subscriptionPrice = parseInt($product.data('subscription-price')) || oneTimePrice;
      const servings = parseInt($product.data('servings')) || 1;

      // For empty bundle, always reset cards to the default (one-time) base prices.
      let displayPrice = oneTimePrice;
      if (totalQuantity > 0) {
        const modeBasePrice = this.isSubscription ? subscriptionPrice : oneTimePrice;
        displayPrice = shouldApplyThresholdDiscount
          ? Math.round(modeBasePrice * (1 - thresholdDiscount / 100))
          : modeBasePrice;
      }

      // Calculate price per serving
      const pricePerServing = servings > 0 ? Math.round(displayPrice / servings) : 0;

      // Update price displays
      const $priceBag = $product.find('.pdp-main-bb__category-product-price-bag');
      const $priceServing = $product.find('.pdp-main-bb__category-product-price-serving');

      if ($priceBag.length) {
        $priceBag.text(this.formatMoney(displayPrice) + $priceBag.data('text'));
      }
      if ($priceServing.length) {
        $priceServing.text(this.formatMoney(pricePerServing) + $priceServing.data('text'));
      }
    });
  },

  frequencySelector() {
    const self = this;
    $('.pdp-main__frequency').on('click', function () {
      const $clicked = $(this);
      const isSub = $clicked.data('frequency') === true;
      self.isSubscription = isSub;
      $('.pdp-main__frequency').removeClass('active');
      $clicked.addClass('active');

      if (isSub) {
        self.applySellingPlanToSelectedProducts(self.getActiveSellingPlanFromUI());
      } else {
        self.applySellingPlanToSelectedProducts({ sellingPlanId: undefined, sellingPlanName: undefined });
      }

      self.calculatePrice();
    });

    // Handle frequency selector plan clicks
    $(document).on('click', '.pdp-main__frequency-selector-plan', function (e) {
      e.stopPropagation();
      const $clicked = $(this);
      const plan = self.readSellingPlanFromElement($clicked);

      $('.pdp-main__frequency-selector-plan').removeClass('active');
      $clicked.addClass('active');

      self.mirrorSellingPlanOntoSubRow(plan);
      self.applySellingPlanToSelectedProducts(plan);
      self.calculatePrice();
    });

    $(document).on('keydown', '.pdp-main__frequency-selector-dropdown .pdp-main__frequency-selector-plan', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      $(this).trigger('click');
    });
  },

  getZeroStateFrequencyTitleContext($subFrequencyTitle) {
    const defaultQuantity = parseInt($subFrequencyTitle.attr('data-default-quantity'), 10) || 1;
    const defaultPricePerServing = ($subFrequencyTitle.attr('data-default-price-per-serving') || '').trim();

    return {
      quantity: defaultQuantity,
      pricePerServingFormatted: defaultPricePerServing
    };
  },

  formatFrequencyTitle(rawText, { sellingPlanName, quantity, pricePerServingFormatted } = {}) {
    if (!rawText) return '';

    let text = rawText;
    const qty = Number(quantity) || 0;

    if (text.includes('[frequency]')) {
      text = text.replace(/\[frequency\]/g, sellingPlanName != null ? String(sellingPlanName) : '');
    }
    if (text.includes('[quantity]')) {
      text = text.replace(/\[quantity\]/g, qty > 0 ? String(qty) : '');
    }
    if (text.includes('[price_per_serving]')) {
      text = text.replace(/\[price_per_serving\]/g, pricePerServingFormatted || '');
    }
    if (text.includes('[s]')) {
      text = text.replace(/\[s\]/g, qty > 1 ? 's' : '');
    }

    return text;
  },

  updateDynamicFrequencyText(product, prices) {
    const totalServings = this.getTotalServings();
    const $oneTimeFrequency = $('.pdp-main__frequency.one-time');
    const $subscriptionFrequency = $('.pdp-main__frequency.sub');

    if ($oneTimeFrequency.length) {
      // Update dynamic frequency text for one-time
      const $oneTimeFrequencyText = $oneTimeFrequency.find('.pdp-main__frequency-text-dynamic');
      $oneTimeFrequencyText.each((index, element) => {
        const $textEl = $(element);
        if (totalServings > 0) {
          const rawText = $textEl.attr('data-text') || $textEl.text();
          let updatedText = rawText;
          if (rawText.includes('[servings]')) {
            updatedText = updatedText.replace(/\[servings\]/g, totalServings);
          }
          $textEl.text(updatedText).removeClass('hidden');
        } else {
          $textEl.addClass('hidden');
        }
      });
    }

    if ($subscriptionFrequency.length) {
      const $subFrequencyTitle = $subscriptionFrequency.find('.pdp-main__frequency-text h3');
      const subFrequencyTitleRaw = $subFrequencyTitle.attr('data-text') || '';
      const titleTokenPattern = /\[(frequency|quantity|price_per_serving|s)\]/;

      if ($subFrequencyTitle.length && titleTokenPattern.test(subFrequencyTitleRaw)) {
        const totalQuantity = prices?.totalQuantity ?? this.getTotalQuantity();
        const subscriptionPrices = prices?.subscription;

        const titleContext = totalQuantity > 0 && subscriptionPrices
          ? {
              quantity: totalQuantity,
              pricePerServingFormatted: subscriptionPrices.pricePerServingFormatted
            }
          : this.getZeroStateFrequencyTitleContext($subFrequencyTitle);

        const frequencyCtx = this.resolveFrequencyTextContext(product);
        $subFrequencyTitle.text(
          this.formatFrequencyTitle(subFrequencyTitleRaw, {
            sellingPlanName: frequencyCtx.sellingPlanName,
            quantity: titleContext.quantity,
            pricePerServingFormatted: titleContext.pricePerServingFormatted
          })
        );
      }

      const $subFrequencyText = $('.pdp-main__frequency.sub .pdp-main__frequency-text-dynamic');
      $subFrequencyText.each((index, element) => {
        const $textEl = $(element);
        if (totalServings > 0) {
          const rawText = $textEl.attr('data-text') || $textEl.text();
          let updatedText = rawText;
          if (rawText.includes('[servings]')) {
            updatedText = updatedText.replace(/\[servings\]/g, totalServings);
          }
          $textEl.text(updatedText).removeClass('hidden');
        } else {
          $textEl.addClass('hidden');
        }
      });
    }
  },

  getPricesPer(prices) {
    const totalServings = this.getTotalServings();
    const priceTypes = ['oneTime', 'subscription'];
    const result = priceTypes.reduce((acc, type) => {
      const pricePerQuantity = prices[type].price / prices.totalQuantity;
      const pricePerQuantityCompare = prices[type].comparePrice / prices.totalQuantity;
      const pricePerServing = pricePerQuantity / (totalServings / prices.totalQuantity);

      acc[type] = {
        pricePerQuantity,
        pricePerQuantityFormatted: this.formatMoney(pricePerQuantity),
        pricePerQuantityCompare,
        pricePerQuantityCompareFormatted: this.formatMoney(pricePerQuantityCompare),
        pricePerServing,
        pricePerServingFormatted: this.formatMoney(pricePerServing)
      };
      return acc;
    }, {});

    this.log.collapse({ prices, totalServings, result }, 'pricePerServing');
    return result;
  },

  bundlePriceMode(price, comparePrice, saveAmount) {
    return {
      price,
      priceFormatted: this.formatMoney(price),
      comparePrice,
      comparePriceFormatted: this.formatMoney(comparePrice),
      saveAmount,
      saveAmountFormatted: this.formatMoney(saveAmount)
    };
  },

  emptyBundlePriceMode() {
    const zf = this.formatMoney(0);
    return {
      ...this.bundlePriceMode(0, 0, 0),
      pricePerQuantity: 0,
      pricePerQuantityFormatted: zf,
      pricePerQuantityCompare: 0,
      pricePerQuantityCompareFormatted: zf,
      pricePerServing: 0,
      pricePerServingFormatted: zf
    };
  },

  emptyBundleFrequencyPrices() {
    const mode = this.emptyBundlePriceMode();
    return {
      oneTime: { ...mode },
      subscription: { ...mode },
      totalQuantity: 0,
      available: true,
      thresholdDiscount: 0,
      discountPercentage: 0,
      subscriptionSaveAmount: 0,
      subscriptionSavePerProduct: 0
    };
  },

  calculatePrice() {
    if (this.selectedProducts.size === 0) {
      this.updateFrequencyPrices(this.emptyBundleFrequencyPrices());
      this.updateMainPriceDisplay({ price: 0, comparePrice: 0, saveAmount: 0, available: false });
      this.updateProductCardPrices();
      return;
    }

    let oneTimeTotalPrice = 0;
    let subscriptionTotalPrice = 0;
    let totalComparePrice = 0;
    let allAvailable = true;

    for (const [variantId, product] of this.selectedProducts) {
      if (product.quantity === 0) continue;
      oneTimeTotalPrice += product.price * product.quantity;
      const subPrice = product.sellingPlanId ? product.subscriptionPrice : product.price;
      subscriptionTotalPrice += subPrice * product.quantity;
      totalComparePrice += product.comparePrice * product.quantity;
      if (!product.available) allAvailable = false;
    }

    // Get threshold discount from progress bar
    const thresholdDiscount = this.getThresholdDiscount();
    const originalSubscriptionPrice = subscriptionTotalPrice;
    if (thresholdDiscount > 0) {
      // Apply threshold discount to subscription price only
      subscriptionTotalPrice = Math.round(subscriptionTotalPrice * (1 - thresholdDiscount / 100));
    }

    const oneTimeSaveAmount = totalComparePrice - oneTimeTotalPrice;

    // For subscription, compare price should be one-time price when threshold discount is applied
    const subscriptionComparePrice = thresholdDiscount > 0 ? oneTimeTotalPrice : totalComparePrice;
    const subscriptionSaveAmount = subscriptionComparePrice - subscriptionTotalPrice;

    // Calculate discount percentage for benefits
    // If threshold discount exists, use that. Otherwise calculate from price difference
    let discountPercentage = thresholdDiscount;
    if (discountPercentage === 0 && oneTimeTotalPrice > 0) {
      const priceDiff = oneTimeTotalPrice - originalSubscriptionPrice;
      discountPercentage = Math.round((priceDiff / oneTimeTotalPrice) * 100);
    }

    // Calculate save per product (save amount divided by total quantity)
    const totalQuantity = this.getTotalQuantity();
    const subscriptionSavePerProduct = totalQuantity > 0 ? Math.round(subscriptionSaveAmount / totalQuantity) : 0;

    let prices = {
      oneTime: this.bundlePriceMode(oneTimeTotalPrice, totalComparePrice, oneTimeSaveAmount),
      subscription: this.bundlePriceMode(subscriptionTotalPrice, subscriptionComparePrice, subscriptionSaveAmount),
      totalQuantity
    };
    const pricesPer = this.getPricesPer(prices);
    prices = {
      "oneTime": {
        ...prices.oneTime,
        ...pricesPer.oneTime
      },
      "subscription": {
        ...prices.subscription,
        ...pricesPer.subscription
      }
    }

    this.updateFrequencyPrices({
      ...prices,
      available: allAvailable,
      thresholdDiscount: thresholdDiscount,
      discountPercentage: discountPercentage,
      subscriptionSaveAmount: subscriptionSaveAmount,
      subscriptionSavePerProduct: subscriptionSavePerProduct,
      totalQuantity
    });

    this.updateMainPriceDisplay({
      price: this.isSubscription ? subscriptionTotalPrice : oneTimeTotalPrice,
      comparePrice: this.isSubscription ? subscriptionComparePrice : totalComparePrice,
      saveAmount: this.isSubscription ? subscriptionSaveAmount : oneTimeSaveAmount,
      available: allAvailable
    });

    // Update product card prices
    this.updateProductCardPrices();
  },

  getThresholdDiscount() {
    const progressBar = document.getElementById('bundle-progress-bar');
    if (!progressBar) return 0;

    const reachedThresholds = progressBar.querySelectorAll('.bundle-picker__threshold[data-reached="true"]');
    if (reachedThresholds.length === 0) return 0;

    // Find the highest reached threshold (highest threshold value)
    let highestThreshold = null;
    let highestValue = -1;

    reachedThresholds.forEach(threshold => {
      const thresholdValue = parseInt(threshold.dataset.threshold) || 0;
      if (thresholdValue > highestValue) {
        highestValue = thresholdValue;
        highestThreshold = threshold;
      }
    });

    if (!highestThreshold) return 0;

    const discount = parseInt(highestThreshold.dataset.discount) || 0;
    return discount > 0 ? discount : 0;
  },

  getThresholdDiscountForQuantity(quantity) {
    const progressBar = document.getElementById('bundle-progress-bar');
    if (!progressBar || quantity <= 0) return 0;

    const thresholds = progressBar.querySelectorAll('.bundle-picker__threshold[data-threshold][data-discount]');
    if (!thresholds.length) return 0;

    let highestValue = -1;
    let bestDiscount = 0;

    thresholds.forEach((threshold) => {
      const thresholdValue = parseInt(threshold.dataset.threshold) || 0;
      if (thresholdValue <= quantity && thresholdValue > highestValue) {
        highestValue = thresholdValue;
        bestDiscount = parseInt(threshold.dataset.discount) || 0;
      }
    });

    return bestDiscount > 0 ? bestDiscount : 0;
  },
  getMinPriceProduct() {
    const $products = $('.pdp-main-bb__category-product');
    let $minPriceProduct = $();
    let minPrice = Infinity;
    $products.each(function () {
      const $product = $(this);
      const price = parseInt($product.attr('data-price'), 10);
      if (!isNaN(price) && price < minPrice) {
        minPrice = price;
        $minPriceProduct = $product;
      }
    });
    return $minPriceProduct;
  },

  getZeroStateStartingPrice(modeKey) {
    const $minPriceProduct = this.getMinPriceProduct();
    if (!$minPriceProduct.length) return 0;

    const oneTimePrice = parseInt($minPriceProduct.attr('data-price'), 10) || 0;
    const subscriptionPrice = parseInt($minPriceProduct.attr('data-subscription-price'), 10) || oneTimePrice;

    if (modeKey !== 'subscription') return oneTimePrice;

    const thresholdDiscount = this.getThresholdDiscountForQuantity(1);
    if (thresholdDiscount <= 0) return subscriptionPrice;

    return Math.round(subscriptionPrice * (1 - thresholdDiscount / 100));
  },

  getZeroStatePriceText(rawText, modeKey) {
    if (!rawText) return '';

    if (!rawText.includes('[price]')) return rawText;

    const startingPrice = this.getZeroStateStartingPrice(modeKey);
    return rawText.replace(/\[price\]/g, this.formatMoney(startingPrice));
  },

  updateFrequencyPrices(prices) {
    const syncFrequencyRow = ($root, $prices, mode, saveSelector, modeKey) => {
      if (!$prices.length) return;
      const isPricesPer = $prices.hasClass('pdp-main__prices--per');
      const $comparePrice = $prices.find('s');
      const $currentPrice = $prices.find('h3');
      const $saveText = $root.find(saveSelector);
      const $pricePerServing = $root.find('p.pdp-main__prices-per-serving');
      const perServingSuffix = $pricePerServing.data('text') || '';
      const hidePerServingInPrices = $root.attr('data-hide-prices-per-serving') === 'true';
      const zeroStatePriceText = ($root.attr('data-zero-state-price-text') || '').trim();

      if (prices.totalQuantity === 0 && zeroStatePriceText) {
        $currentPrice.text(this.getZeroStatePriceText(zeroStatePriceText, modeKey));
        $comparePrice.addClass('hidden');
        if ($pricePerServing.length) $pricePerServing.addClass('hidden');
        if ($saveText.length) $saveText.addClass('hidden');
        return;
      }

      const displayPrice = isPricesPer ? mode.pricePerQuantityFormatted : mode.priceFormatted;
      const displayComparePrice = isPricesPer ? mode.pricePerQuantityCompareFormatted : mode.comparePriceFormatted;

      $currentPrice.text(displayPrice + ($currentPrice.data('text') || ''));

      if (mode.comparePrice > mode.price) {
        $comparePrice.text(displayComparePrice).removeClass('hidden');
      } else {
        $comparePrice.addClass('hidden');
      }

      if (isPricesPer && mode.pricePerServing > 0 && !hidePerServingInPrices) {
        $pricePerServing.text(mode.pricePerServingFormatted + perServingSuffix).removeClass('hidden');
      } else {
        $pricePerServing.addClass('hidden');
      }

      if (!isPricesPer && $saveText.length && mode.saveAmount > 0) {
        $saveText.text(`You're Saving ${mode.saveAmountFormatted}`).removeClass('hidden');
      } else if ($saveText.length) {
        $saveText.addClass('hidden');
      }
    };

    const $oneTimeFrequency = $('.pdp-main__frequency.one-time');
    if ($oneTimeFrequency.length) {
      syncFrequencyRow(
        $oneTimeFrequency,
        $oneTimeFrequency.find('.pdp-main__prices'),
        prices.oneTime,
        '.pdp-main__frequency-save-price, p.pdp-main__frequency-save-price',
        'oneTime'
      );
    }

    const $subscriptionFrequency = $('.pdp-main__frequency.sub');
    if ($subscriptionFrequency.length) {
      syncFrequencyRow(
        $subscriptionFrequency,
        $subscriptionFrequency.find('.pdp-main__frequency-prices-wrapper .pdp-main__prices'),
        prices.subscription,
        '.pdp-main__frequency-save-price',
        'subscription'
      );
    }

    if ($subscriptionFrequency.length) {
      // Update dynamic frequency announcement
      const $subscriptionAnnouncement = $subscriptionFrequency.closest('.pdp-main__frequency-announcement-wrapper').find('.pdp-main__frequency-announcement[data-dynamic="true"]');
      if ($subscriptionAnnouncement.length && prices.discountPercentage !== undefined && prices.subscriptionSaveAmount !== undefined) {
        const rawText = $subscriptionAnnouncement.attr('data-text') || $subscriptionAnnouncement.text();
        let updatedText = rawText;

        // Replace [sub_discount] with formatted save amount (money value) - no trailing zeros
        if (rawText.includes('[sub_discount]')) {
          updatedText = updatedText.replace(/\[sub_discount\]/g, this.formatMoneyNoTrailingZeros(prices.subscriptionSaveAmount));
        }

        // Replace [sub_discount_perc] with discount percentage
        if (rawText.includes('[sub_discount_perc]')) {
          updatedText = updatedText.replace(/\[sub_discount_perc\]/g, `${prices.discountPercentage}%`);
        }

        // Replace [sub_discount_each] with formatted save per product (money value) - no trailing zeros
        if (rawText.includes('[sub_discount_each]') && prices.subscriptionSavePerProduct !== undefined) {
          updatedText = updatedText.replace(/\[sub_discount_each\]/g, this.formatMoneyNoTrailingZeros(prices.subscriptionSavePerProduct));
        }

        $subscriptionAnnouncement.text(updatedText);
      }

      // Update dynamic benefits
      if (prices.discountPercentage !== undefined && prices.subscriptionSaveAmount !== undefined) {
        const $dynamicBenefits = $subscriptionFrequency.find('.pdp-main__benefit p[data-dynamic="true"]');
        $dynamicBenefits.each((index, element) => {
          const $benefitText = $(element);
          const rawText = $benefitText.attr('data-benefit-text') || $benefitText.text();

          let updatedText = rawText;

          // Replace [sub_discount] with formatted save amount (money value) - no trailing zeros for benefits
          if (rawText.includes('[sub_discount]')) {
            updatedText = updatedText.replace(/\[sub_discount\]/g, this.formatMoneyNoTrailingZeros(prices.subscriptionSaveAmount));
          }

          // Replace [sub_save_perc] with discount percentage
          if (rawText.includes('[sub_save_perc]')) {
            updatedText = updatedText.replace(/\[sub_save_perc\]/g, `${prices.discountPercentage}%`);
          }

          // Replace [sub_discount_each] with formatted save per product (money value) - no trailing zeros for benefits
          if (rawText.includes('[sub_discount_each]') && prices.subscriptionSavePerProduct !== undefined) {
            updatedText = updatedText.replace(/\[sub_discount_each\]/g, this.formatMoneyNoTrailingZeros(prices.subscriptionSavePerProduct));
          }

          $benefitText.text(updatedText);
        });
      }
    }

    this.updateDynamicFrequencyText(null, prices);
  },

  updateMainPriceDisplay(prices) {
    if (!prices) return;

    const priceFormatted = this.formatMoney(prices.price);
    const compareFormatted = this.formatMoney(prices.comparePrice);
    const saveFormatted = this.formatMoney(prices.saveAmount);

    const $pricesEl = $('.pdp-main__content > .pdp-main__prices');
    if ($pricesEl.length) {
      const $comparePrice = $pricesEl.find('s');
      const $currentPrice = $pricesEl.find('h3');
      const $saveText = $pricesEl.find('p');

      $currentPrice.text(priceFormatted);

      if (prices.comparePrice > prices.price) {
        $comparePrice.text(compareFormatted).removeClass('hidden');
      } else {
        $comparePrice.addClass('hidden');
      }

      if (prices.saveAmount > 0) {
        $saveText.text(`Save ${saveFormatted}`).removeClass('hidden');
      } else {
        $saveText.addClass('hidden');
      }
    }

    if (this.klarna.length > 0) {
      const divideBy = Number(this.klarna.data('divide')) || 4;
      const klarnaAmount = prices.price / divideBy;
      this.klarna.text(this.formatMoney(klarnaAmount));
    }

    const atcBtn = $('.pdp-main__atc-btn');
    if (!prices.available || prices.price === 0) {
      const atcMainText = atcBtn.find('span:not(.money)').data('main-text') || 'Add to Cart';
      atcBtn.prop('disabled', true).addClass('soldout').attr('data-available', false).find('span:not(.money)').text(atcMainText);
      atcBtn.find('.money').text('');
    } else {
      const atcMainText = atcBtn.find('span:not(.money)').data('main-text') || 'Add to Cart';
      atcBtn.prop('disabled', false).removeClass('soldout').attr('data-available', true).find('span:not(.money)').text(atcMainText);
      atcBtn.find('.money').text(priceFormatted);
    }
  },

  initUpdate() {
    const activeFrequency = $('.pdp-main__frequency.active');
    if (activeFrequency.length) {
      this.isSubscription = activeFrequency.data('frequency') === true;
    }
    this.initATCButton();
    this.bundleBuilderSelector();
    this.frequencySelector();
    this.initPreaddedProduct();
    this.calculatePrice();
  },

  initATCButton() {
    const atcBtn = $('.pdp-main__atc-btn');
    if (atcBtn.length) {
      const atcMainText = atcBtn.find('span:not(.money)').data('main-text') || atcBtn.find('span:not(.money)').text() || 'Add to Cart';
      atcBtn.prop('disabled', true).attr('data-available', false);
      atcBtn.find('span:not(.money)').text(atcMainText);
      atcBtn.find('.money').text('');
    }
  },

  addToCart() {
    const self = this;
    const showATCToastIfNeeded = ({ isSoldout, preferNoSelection } = {}) => {
      if (!window.showToast) return;
      if (preferNoSelection && self.selectedProducts.size === 0) {
        window.showToast('bundle_builder_no_selection');
        return;
      }
      if (isSoldout) {
        const productTitle = $('.pdp-main').data('product-title') || document.title?.split('|')[0]?.trim() || 'This product';
        window.showToast('soldout_product', { productTitle });
        return;
      }
      if (self.selectedProducts.size === 0) {
        window.showToast('bundle_builder_no_selection');
      }
    };

    const handleAddToCart = ({ forceOneTimePurchase } = {}) => {
      const cartUrl = window.getCartUrl();
      if (self.selectedProducts.size === 0) {
        showATCToastIfNeeded({ isSoldout: false });
        return;
      }

      const items = [];
      for (const [, product] of self.selectedProducts) {
        if (product.quantity === 0) continue;
        const item = {
          id: product.variantId,
          quantity: product.quantity
        };
        if (!forceOneTimePurchase && self.isSubscription && product.sellingPlanId) {
          item.selling_plan = product.sellingPlanId;
        }
        items.push(item);
      }

      $.post('/cart/add.js', { items })
        .done(() => {
          if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
          else window.location.href = cartUrl;
        })
        .fail(() => alert('Error adding item to cart.'));
    };

    $('.pdp-main__atc-btn').on('click', function (e) {
      e.preventDefault();
      const $btn = $(this);
      if ($btn.prop('disabled') || $btn.hasClass('soldout') || !$btn.data('available')) {
        showATCToastIfNeeded({ isSoldout: $btn.hasClass('soldout') });
        return;
      }
      handleAddToCart({ forceOneTimePurchase: false });
    });

    $('#below-main-otp-atc-button').on('click', function (e) {
      e.preventDefault();

      const $mainBtn = $('.pdp-main__atc-btn');
      if ($mainBtn.length) {
        const mainAvailable = !!$mainBtn.data('available');
        if ($mainBtn.prop('disabled') || $mainBtn.hasClass('soldout') || !mainAvailable) {
          showATCToastIfNeeded({ isSoldout: $mainBtn.hasClass('soldout'), preferNoSelection: true });
          return;
        }
      }

      handleAddToCart({ forceOneTimePurchase: true });
    });
  }
};

$(document).ready(function () {
  Product.init();
});
